import Workpage from './Workpage';
import DC from './fields';
import TextDisplay from './TextDisplay';
import WorkTray from './WorkTray';
import WorkTrayIcon from './WorkTrayIcon';
import EntityWidget from './EntityWidget';
import EntitySummary from './EntitySummary';
import EventScheduler from './EventScheduler';
import Dashboard from './Dashboard';
import NewReportBtn from '../ocifComponents/NewReportBtn';
import InventoryScheduleManager from '../ocifComponents/InventoryScheduleManager';
import CardTray from './CardTray';
import WorkpageForm from './WorkpageForm';

const WORKPAGE_COMPONENTS = DC;
WORKPAGE_COMPONENTS.worktray = WorkTray;
WORKPAGE_COMPONENTS.workpageForm = WorkpageForm;
// WORKPAGE_COMPONENTS.entity = EntityWidget;
WORKPAGE_COMPONENTS.button = WorkTrayIcon;
// WORKPAGE_COMPONENTS.eventScheduler = EventScheduler;
WORKPAGE_COMPONENTS.text = TextDisplay;
// WORKPAGE_COMPONENTS.summary = EntitySummary;
WORKPAGE_COMPONENTS.dashboard = Dashboard;
WORKPAGE_COMPONENTS.cardtray = CardTray;

WORKPAGE_COMPONENTS.ocif_newReportBtn = NewReportBtn;
WORKPAGE_COMPONENTS.ocif_inventoryScheduleManager = InventoryScheduleManager;

export { WORKPAGE_COMPONENTS };
export default Workpage;
